import { constants } from "@newsela/angelou";

export const defaultAdditionalAccessibilityOptions = {
  keyboardNavigation: {
    enabled: true,
    order: ["chartMenu", "legend", "series"],
    focusBorder: {
      style: {
        lineWidth: 2,
        color: constants.colors.ui.core[700],
        borderRadius: 5,
      },
      margin: 4,
    },
  },
};
